import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  cartTitle: {
    id: 'cart.drawer.title',
    defaultMessage: 'Cart',
    description: 'Title for the cart drawer',
  },
  courseBadge: {
    id: 'cart.item.badge.course',
    defaultMessage: 'Course',
    description: 'Badge text for course items in cart',
  },
  programBadge: {
    id: 'cart.item.badge.program',
    defaultMessage: 'Program',
    description: 'Badge text for program items in cart',
  },
  removeButton: {
    id: 'cart.item.button.remove',
    defaultMessage: 'Remove',
    description: 'Button text to remove item from cart',
  },
  moveToWishlistButton: {
    id: 'cart.item.button.wishlist',
    defaultMessage: 'Move to Wishlist',
    description: 'Button text to move item to wishlist',
  },
  subtotalLabel: {
    id: 'cart.footer.subtotal',
    defaultMessage: 'Subtotal',
    description: 'Label for subtotal amount in cart',
  },
  cancelButton: {
    id: 'cart.footer.button.cancel',
    defaultMessage: 'Cancel',
    description: 'Button text to cancel/close cart drawer',
  },
  checkoutButton: {
    id: 'cart.footer.button.checkout',
    defaultMessage: 'Checkout',
    description: 'Button text for proceeding to checkout',
  },
  enrollFreeButton: {
    id: 'cart.footer.button.enroll.free',
    defaultMessage: 'Enroll Now',
    description: 'Button text for enrolling in free courses',
  },
  paymentGatewayDisabled: {
    id: 'cart.footer.payment.disabled',
    defaultMessage: 'Payment Gateway Disabled',
    description: 'Message shown when payment gateway is disabled',
  },
});

export default messages; 